import { render } from "./ProfileCryptosWrappedV1.1.vue?vue&type=template&id=b0be5154&scoped=true"
import script from "./ProfileCryptosWrappedV1.1.vue?vue&type=script&lang=js"
export * from "./ProfileCryptosWrappedV1.1.vue?vue&type=script&lang=js"

import "./ProfileCryptosWrappedV1.1.vue?vue&type=style&index=0&id=b0be5154&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b0be5154"]])

export default __exports__